import Tab from "bootstrap/js/src/tab";

const TAB_TRIGGERS = document.querySelectorAll('.tabs [data-bs-toggle="tab"]');
const TAB_LIST = document.querySelector('.tabs [role="tablist"]');
const TAB_HOLDER = document.querySelector('.tabs #tabs-content');
const TABS = document.querySelectorAll('.tabs [role="tabpanel"]');

TAB_TRIGGERS.forEach(TRIGGER => new Tab(TRIGGER));

const SCROLL_TO_ITEM = upcomingElement => {
  const activeItemOffset = upcomingElement.offsetLeft
  const contentOffset = TAB_HOLDER.offsetLeft
  TAB_LIST.scroll({
    left: activeItemOffset - contentOffset,
    top: 0,
    behavior: 'smooth'
  })
}

const ACTIVATE_UPCOMING_TAB = tabElement => Tab.getInstance(tabElement).show();

const AUTOPLAY_INTERVAL = () => setInterval(() => {
  const UPCOMING_TAB_ELEMENT = document.querySelector('.tabs [data-bs-toggle="tab"].next');
  const NEXT_TAB_ELEMENT = UPCOMING_TAB_ELEMENT.nextElementSibling || TAB_TRIGGERS[0];

  UPCOMING_TAB_ELEMENT.classList.remove('next');
  NEXT_TAB_ELEMENT.classList.add('next');

  ACTIVATE_UPCOMING_TAB(UPCOMING_TAB_ELEMENT);
  SCROLL_TO_ITEM(UPCOMING_TAB_ELEMENT)

}, 5000);

const SET_RELATIVE_TAB = TABS => {
  if (TABS) {
    let relativeElementHeight = TABS[0].getBoundingClientRect().height;
    const RELATIVE_ELEMENT = TAB_HOLDER.querySelector('[role="tabpanel"].position-relative');

    TABS.forEach(TAB => {
      const TEXT_HEIGHT = TAB.querySelector('[data-text-col]').getBoundingClientRect().height;
      if (TEXT_HEIGHT > relativeElementHeight) {
        relativeElementHeight = TEXT_HEIGHT;
        RELATIVE_ELEMENT.classList.remove('position-relative');
        TAB.classList.add('position-relative');
      }
    })
  }
}


export function INIT_TABS() {
  if (!TAB_TRIGGERS) return;
  let interval;

  SET_RELATIVE_TAB(TABS);
  window.addEventListener('resize', () => {
    SET_RELATIVE_TAB(TABS);
  })

  const INIT_OBSERVER = new IntersectionObserver(ENTRIES => {
    ENTRIES.forEach(ENTRY => {
      if (ENTRY.isIntersecting) {
        if (!ENTRY.target.classList.contains('progressing')) {
          ENTRY.target.classList.add('progressing');
          interval = AUTOPLAY_INTERVAL();
        }
      }
    })
  })

  INIT_OBSERVER.observe(TAB_LIST);

  TAB_TRIGGERS.forEach(TRIGGER => {

    const TAB_TRIGGER = Tab.getInstance(TRIGGER);
    const OBSERVER = new IntersectionObserver(ENTRIES => {
      ENTRIES.forEach(ENTRY => {

        if (!ENTRY.isIntersecting) {
          const TARGET_TAB = ENTRY.target;
          if (TARGET_TAB.classList.contains('clicked')) {
            TARGET_TAB.classList.remove('clicked')
            interval = AUTOPLAY_INTERVAL();
          }
        }
      })
    })

    TRIGGER.addEventListener('click', event => {

      event.preventDefault();
      const ALL_CLICKED_ITEMS = document.querySelectorAll('[data-bs-toggle="tab"].clicked');
      const NEXT_ITEM = document.querySelector('.tabs [data-bs-toggle="tab"].next')
      const SIBLING_ITEM = TRIGGER.nextElementSibling || TAB_TRIGGERS[0];

      TAB_TRIGGER.show();
      SCROLL_TO_ITEM(TRIGGER);
      clearInterval(interval);

      ALL_CLICKED_ITEMS.forEach(item => item.classList.remove('clicked'));
      TRIGGER.classList.add('clicked');
      NEXT_ITEM.classList.remove('next');
      SIBLING_ITEM.classList.add('next');

    })

    OBSERVER.observe(TRIGGER);
  });
}
